import { PostingRulesPage } from '@/pages/shared/posting-rules';

export function TradingPostingRulesPage() {
  return <PostingRulesPage app="TRADING" />;
}
